import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpEvaluatorService from '../../../Services/TpEvaluatorService';

// The dialog's edited item. TpEvaluatorAdmin seeds it from the clicked (primary) row.
export class AttachTpEvaluatorParams {
  constructor(primaryItem = null) {
    this.PrimaryTpEvaluatorId = primaryItem?.TpEvaluatorId ?? null;
    this.PrimaryLabel = primaryItem ? `#${primaryItem.TpEvaluatorId} ${primaryItem.Name}` : '';
    this.TpEvaluatorId = null;
    this.Reason = '';
  }
}

// CD-5527: "Attach TP Evaluator" dialog opened from a TpEvaluator row. The row is the PRIMARY (the canonical
// profile); the user picks the duplicate profile to hang under it and gives a reason.
export default class AttachTpEvaluatorWindowDescription extends React.Component {
  static titleForCreate = 'Attach TP Evaluator to this profile';
  static titleForEdit = 'Attach TP Evaluator to this profile';
  static finishButtonLabel = 'Attach';
  static itemType = AttachTpEvaluatorParams;
  static serviceFunction = (edited) =>
    TpEvaluatorService.AttachToPrimary({
      TpEvaluatorId: edited.TpEvaluatorId,
      PrimaryTpEvaluatorId: edited.PrimaryTpEvaluatorId,
      Reason: edited.Reason,
    });
  static messageOnSuccess =
    'The profile is now linked. It disappears from the list and its payments are exported under this primary profile from now on.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'PrimaryLabel',
          label: 'Primary TP Evaluator',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
        },
        {
          fieldName: 'TpEvaluatorId',
          label: 'TP Evaluator to attach',
          className: 'col-12',
          type: InputTypesEnum.TpEvaluatorSelect,
          info: 'Type at least 3 characters of the email, or the Bravo TP Evaluator ID.',
          validityChecker: ValidityHelper.forTpEvaluatorAttachCheck,
        },
        {
          fieldName: 'Reason',
          label: 'Reason',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];
}
